/**
 * Payload de los eventos switch_plan_annual / switch_plan_monthly del checkout.
 *
 * `to` es lo que se sabe del plan de destino ANTES de pedirlo: el `relatedPlan`
 * del mensual (id, chargeFrecuency, originalCost) o el mensual con el que se
 * abrio el checkout. No puede salir del plan abierto: al volver al mensual el
 * abierto es el anual, que no tiene relacionado (VEX-6997).
 */
export function planSwitchPayload(from, to) {
  return {
    fromPlan: from.id,
    toPlan: to.id,
    fromFrequency: from.chargeFrecuency,
    toFrequency: to.chargeFrecuency,
    fromPrice: from.originalCost,
    toPrice: to.originalCost
  };
}
